import { render, staticRenderFns } from "./Keterlambatan.vue?vue&type=template&id=01c78d23&scoped=true"
import script from "./Keterlambatan.vue?vue&type=script&lang=js"
export * from "./Keterlambatan.vue?vue&type=script&lang=js"
import style0 from "./Keterlambatan.vue?vue&type=style&index=0&id=01c78d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c78d23",
  null
  
)

export default component.exports